import { Component, OnInit,Output,EventEmitter,Input } from '@angular/core';
import { Dep } from './../../comm/class/auth';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-otnavbarpc',
  templateUrl: './otnavbarpc.component.html',
  styleUrls: ['./otnavbarpc.component.css']
})
export class OtnavbarpcComponent implements OnInit {

	constructor(private route:ActivatedRoute,private router:Router) { }
	@Output() change_status: EventEmitter<boolean> = new EventEmitter();
	@Input() user:  any;
	ngOnInit(): void {
	}
  
	logout(){
	  const  identity = Dep.getData().partner;
	  Dep.logout();
	  if(identity==1){
		this.router.navigate(['/', 'login']);
	  }else{
		this.router.navigate(['/', 'signin']);
	  }
	  this.change_status.emit(false);
	}

}
